import React from 'react';

import {Link} from 'react-router-dom';

import Avatar from '../../../components/Avatar';
import Icon from '../../../components/Icon';
import DateSince from "../../../components/Date";
import createLink from "../../../../libs/createLink";
import Title from "../../../components/Title";
import _ from "lodash";

class CardCategory extends React.Component {
    constructor(props) {
        super(props);
        this.last = this.props;
        this.state = {
            isRead: true
        };
    }


    lastData() {
        this.last = {
            ...this.last,
            count: {
                article: 0,
                comment: 0
            },
            lastComment: {
                authorName: "",
                comment: {
                    title: "",
                    slug: "",
                    createdAt: 0,
                },
                owner: {
                    username: '',
                    slug: '',
                    profile: {
                        avatar: '',
                        gender: 0,
                    },  //
                    role: "",
                }
            }
        };
        let lastTopic = _.orderBy(this.last.childrens, ['lastComment.comment.createdAt'], ['desc']);
        if(lastTopic){
            lastTopic = lastTopic[0];
            this.last.lastComment = lastTopic.lastComment;
            this.last.parentSlug = this.props.slug;
            this.last.parentId = this.props._id;
            this.last.slug = lastTopic.slug;
            this.last._id = lastTopic._id;
        }
        this.last.count.article = _.sumBy(this.last.childrens, 'count.article');
        this.last.count.comment = _.sumBy(this.last.childrens, 'count.comment');
        /*
        this.last.childrens.forEach(item => {
            if (item.count) {
                this.last.count.article = this.last.count.article + item.count.article;
                this.last.count.comment = this.last.count.comment + item.count.comment;
            }
            if (Math.floor((new Date(item.lastComment.comment.createdAt).getTime())) > this.last.lastComment.comment.createdAt > 0 ? Math.floor((new Date(item.lastComment.comment.createdAt).getTime())) : 0) {
                this.last.lastComment = item.lastComment;
                this.last.parentSlug = this.props.slug;
                this.last.parentId = this.props._id;
                this.last.slug = item.slug;
                this.last._id = item._id;
            }

        });*/
        return this.last;
    }

    render() {
        this.last.childrens.length > 0 && this.lastData();
        let categoryParent = (this.props.match.params.slug && this.props.breadcrumbs && this.props.breadcrumbs[1] && this.props.breadcrumbs[1].slug) || "" ;
        return (
            <div className="card-category">
                <div className="wrapper-left">
                    {this.last.isRead ?
                        <div className="icon">
                            <Icon type="comments-o"/>
                        </div>
                        :
                        <div className="icon">
                            {this.last.redirect.url ?
                                <Icon type="link"/>
                                :
                                <Icon type="comment"/>
                            }
                        </div>
                    }
                    <div className="wrapper-card-category">
                        <div className="wrapper-title">
                            <Title className={"title"} heading={"heading-3"} display={"display-0"}>
                                {this.last.redirect.url ?
                                    <a href={this.last.redirect.url}>{this.last.name.length >= 50 ? this.last.name.substring(0, 50) + "..." : this.last.name}</a>
                                    :
                                    <Link to={createLink("forumCategory", {categoryParent: {slug: categoryParent}, category : {slug : this.props.slug, _id : this.props._id}})}>
                                        {this.last.name.length >= 50 ? this.last.name.substring(0, 50) + "..." : this.last.name}
                                    </Link>
                                }
                            </Title>

                            {this.last.childrens.length >= 1 && (
                                <ul className="sub-forums">
                                    {this.last.childrens.map((item, index) => (
                                        <li key={index}>
                                            <Link to={createLink("forumCategory", {categoryParent : {_id : this.props._id, slug : this.props.slug},category : {slug : item.slug, _id : item._id}})}>
                                                {item.name}
                                            </Link>
                                            {index < (this.last.childrens.length - 1) ? ', ' : ''}
                                        </li>
                                    ))}
                                </ul>
                            )}
                            <div className="description">{this.last.description}</div>
                        </div>
                        <div className={`wrapper-infos ${this.last.redirect.url ? 'hidden' : ''}`}>
                            <div className="subjects">
                                <span>{this.last.count && this.last.count.article}</span>&nbsp;sujets
                            </div>
                            <div className="views-text">
                                <span>{this.last.count && this.last.count.comment}</span>&nbsp;réponses
                            </div>
                        </div>
                    </div>
                </div>
                {this.last.lastComment.owner && this.last.lastComment.owner._id ? (
                        <div className={`last-post ${this.last.redirect.url ? 'hidden' : ''}`}>
                            <Link
                                to={createLink("userProfile", this.last.lastComment.owner)}><Avatar
                                avatar={this.last.lastComment.owner.profile.avatar}
                                gender={this.last.lastComment.owner.profile.gender} alt=""/></Link>
                            <div className="wrapper-infos-last">
                                <div className="title-last-post"><Link
                                    to={{
                                        pathname: createLink("forumTopic", {categoryParent : {slug : this.last.parentSlug || categoryParent, _id : this.last.parentId._id}, category : {slug : this.last.slug, _id : this.last._id}, topic : {_id : this.last.lastComment.comment._id, slug : this.last.lastComment.comment.slug}}),
                                        state: { redirectToLastPage: true }
                                    }}
                                    >{this.last.lastComment.comment.title && this.last.lastComment.comment.title.length >= 30 ? this.last.lastComment.comment.title.substring(0, 30) + "..." : this.last.lastComment.comment.title} </Link>
                                </div>
                                <div className="username-last-post">Par <Link className={"username"}
                                                                              to={createLink("userProfile", this.last.lastComment.owner)}>{this.last.lastComment.owner.username}</Link>
                                </div>
                                <div className="text small medium-grey">
                                    {this.last.lastComment.comment.createdAt ?
                                        <DateSince
                                            date={this.last.lastComment.comment.createdAt}
                                            prefix={true}
                                            currentFormat={true}
                                        />
                                        : ''}
                                </div>
                            </div>
                        </div>
                    ) :
                    (
                        <div className={`last-post ${this.last.redirect.url ? 'hidden' : ''}`}>
                            <Avatar gender="guest" alt=""/>
                            <div className="wrapper-infos-last">
                                <div className="title-last-post"><Link
                                    to={createLink("forumTopic", {category : {slug : this.last.slug, _id : this.last._id}, topic : {_id : this.last.lastComment.comment._id, slug : this.last.lastComment.comment.slug}})}>{this.last.lastComment.comment.title && this.last.lastComment.comment.title.length >= 30 ? this.last.lastComment.comment.title.substring(0, 30) + "..." : this.last.lastComment.comment.title}</Link>
                                </div>
                                <div className="username-last-post">
                                    Par Guest_{this.last.lastComment.authorName || ""}
                                </div>
                                <div className="text small medium-grey">
                                    {this.last.lastComment.comment.createdAt ?
                                        <DateSince
                                            date={this.last.lastComment.comment.createdAt}
                                            prefix={true}
                                            currentFormat={true}
                                        />
                                        : ''}
                                </div>
                            </div>
                        </div>
                    )}
            </div>
        )
    }
}

CardCategory.defaultProps = {
    isRead: false,
    slug: '',
    name: '',
    description: '',
    redirect: {
        url: ''
    },
    count: {
        article: 0,
        comment: 0
    },
    lastComment: {
        authorName: "",
        comment: {
            title: "",
            slug: "",
            createdAt: 0,
        },
        owner: {
            username: '',
            slug: '',
            avatar: '',
            gender: 0,
            role: "",
        }
    }

};

export default CardCategory;
